import { useQuery } from '@tanstack/react-query';

import { listParentSquareSavedCards } from '~entities/payment/api/square-payment-methods';
import { fetchStudioDefaultPaymentProviderAPI } from '~entities/studios/api/get-studio-default-payment-provider';
import { PaymentMethod } from '~entities/wallet/model/types';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';
import { isSquarePaymentProvider } from '~shared/lib/square-web-payments';

interface CheckPaymentMethodParams {
  parentId: string;
  paymentMethod: 'card' | 'us_bank_account' | 'au_becs_debit';
}

interface CheckPaymentMethodResponse {
  hasPaymentMethod: boolean;
  cardSurchargeEligible?: boolean;
}

export const checkPaymentMethod = async (params: CheckPaymentMethodParams) => {
  const { paymentProvider } = await fetchStudioDefaultPaymentProviderAPI();
  if (isSquarePaymentProvider(paymentProvider)) {
    if (params.paymentMethod !== PaymentMethod.CARD) {
      return { hasPaymentMethod: false };
    }
    const cards = await listParentSquareSavedCards(params.parentId);
    return {
      hasPaymentMethod: cards.length > 0,
      cardSurchargeEligible: true,
    };
  }

  const response = await baseAPI.post<CheckPaymentMethodResponse>(
    `/payment-processor/check-payment-method`,
    {
      ...params,
    },
  );
  return response.data;
};

export const useCheckPaymentMethod = (params: CheckPaymentMethodParams) => {
  return useQuery({
    queryKey: [KEYS.PAYMENT_METHOD, params.parentId, params.paymentMethod],
    queryFn: () => checkPaymentMethod(params),
    enabled: !!params.parentId && !!params.paymentMethod,
  });
};
